import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const restoreAuthoringDraftRestorePoint = api(async function restoreAuthoringDraftRestorePoint({
    projectId,
    scheduleId,
    restorePointId,
}) {
    return mutate(
        gql`
            mutation RestoreAuthoringDraftRestorePoint(
                $projectId: String!
                $scheduleId: String!
                $restorePointId: String!
            ) {
                restoreAuthoringDraftRestorePoint(
                    projectId: $projectId
                    scheduleId: $scheduleId
                    restorePointId: $restorePointId
                )
            }
        `,
        { projectId, scheduleId, restorePointId },
        { returns: "restoreAuthoringDraftRestorePoint" }
    )
})
